/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import BScroll from '@/components/Bscroll';
import { GetProductList } from '@/api/miniClinic';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import { MUTATION_MINI_PRODUCT_INFO } from '@/store/mutation_types';
import defalutImg from '@/resources/images/default.png';
import ListItem from '@/components/ListItem';
import NoData from '@/components/NoData';
export default {
  data: function data() {
    return {
      pageNo: 1,
      pageSize: 20,
      productEmpty: false,
      productList: [],
      totalPage: 1,
      noData: false,
      defalutImg: defalutImg,
      heightStaus: false,
      productStatus: 0 //1:加载中；2：数据所有加载完成

    };
  },
  created: function created() {
    this.getProductListAjax();
  },
  mounted: function mounted() {},
  components: {
    ListItem: ListItem,
    NoData: NoData,
    BScroll: BScroll
  },
  computed: _objectSpread({}, mapGetters({})),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations({
    MUTATION_MINI_PRODUCT_INFO: MUTATION_MINI_PRODUCT_INFO
  })), mapActions([])), {}, {
    scrollEnd: function scrollEnd() {
      if (this.totalPage <= this.pageNo) {
        this.productStatus = 2;
        return;
      }

      if (!this.noData) {
        // 获取下一页的数据处理
        this.pageNo += 1;
        this.getProductListAjax();
      }
    },
    //
    tapEvent: function tapEvent(item) {
      this.MUTATION_MINI_PRODUCT_INFO(item);
      this.$router.push({
        name: 'MiniClinicProductDetail',
        query: {
          'productId': item.PRODUCTID
        }
      });
    },

    /**
     *  获取特色项目列表
     *
     */
    getProductListAjax: function getProductListAjax() {
      var _this = this;

      GetProductList({
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }).then(function (data) {
        console.log(data);

        if (data && data.dataSource) {
          var _this$productList;

          if (data.totalPage == _this.pageNo) {
            _this.productStatus = 2;
          }

          (_this$productList = _this.productList).push.apply(_this$productList, _toConsumableArray(data.dataSource));
        }

        if (_this.productList.length == 0) {
          _this.productEmpty = true;
        } else {
          _this.productEmpty = false;
        }

        _this.$nextTick(function () {
          var h1 = _this.$refs.productListWrap.offsetHeight,
              h2 = _this.$refs.productListCon.offsetHeight;

          if (h2 > h1) {
            _this.heightStaus = true;
          }
        });
      });
    }
  })
};